<template>
  <div class="gx-mi">
    <!-- ═══════════ 顶部说明栏 ═══════════ -->
    <div class="gx-mi__banner">
      <span class="gx-mi__banner-icon">🖼</span>
      <div class="gx-mi__banner-text">
        <span class="gx-mi__banner-title">AI生成主图</span>
        <span class="gx-mi__banner-desc">复刻对标主图风格，或自定义主图生成方向</span>
      </div>
    </div>

    <!-- ═══════════ Tab 切换 ═══════════ -->
    <div class="gx-mi__tabs">
      <button class="gx-mi__tab" :class="{ 'gx-mi__tab--on': mainTab === 'task' }" @click="mainTab = 'task'">
        <span class="gx-mi__tab-ico gx-mi__tab-ico--gold">✨</span>发布任务
      </button>
      <button class="gx-mi__tab" :class="{ 'gx-mi__tab--on': mainTab === 'record' }" @click="mainTab = 'record'">
        <span class="gx-mi__tab-ico gx-mi__tab-ico--orange">📋</span>生成记录
      </button>
      <button class="gx-mi__tab" :class="{ 'gx-mi__tab--on': mainTab === 'tpl' }" @click="mainTab = 'tpl'">
        <span class="gx-mi__tab-ico gx-mi__tab-ico--gray">📐</span>模板管理
      </button>
    </div>

    <!-- ═══════════════════════════════════════ -->
    <!-- Tab1：发布任务                          -->
    <!-- ═══════════════════════════════════════ -->
    <template v-if="mainTab === 'task'">
      <!-- 步骤条 -->
      <div class="gx-mi__steps">
        <template v-for="(s, i) in steps">
          <div :key="s.n" class="gx-mi__step" :class="stepClass(s.n)">
            <span class="gx-mi__step-dot" v-html="s.n < currentStep ? '✓' : s.n"></span>
            <span class="gx-mi__step-label" :style="s.n < currentStep ? 'color:rgb(82, 196, 26);':''">{{ s.label }}</span>
          </div>
          <div v-if="i < steps.length - 1" :key="'line-' + s.n" class="gx-mi__stepline" :class="{ 'gx-mi__stepline--on': s.n < currentStep }"></div>
        </template>
      </div>

      <!-- ───────── 步骤1：选择商品 ───────── -->
      <div v-if="currentStep === 1">
        <!-- 筛选卡片 -->
        <div class="gx-mi__filter">
          <span class="gx-mi__filter-title">筛选本轮商品</span>
          <span class="gx-mi__filter-hint">历史筛选：暂无 &gt; 未生成主图</span>
          <div class="gx-mi__frow">
            <div class="gx-mi__fitem">
              <label>关键词</label>
              <input v-model="filter.keyword" class="gx-mi__input" placeholder="搜索商品名称" />
            </div>
            <div class="gx-mi__fitem">
              <label>来源ID</label>
              <input v-model="filter.sourceId" class="gx-mi__input" placeholder="1688商品ID" />
            </div>
            <div class="gx-mi__fitem">
              <label>铺货平台ID</label>
              <input v-model="filter.platformId" class="gx-mi__input" placeholder="平台商品ID" />
            </div>
          </div>
          <div class="gx-mi__frow">
            <div class="gx-mi__fitem">
              <label>商品来源</label>
              <select v-model="filter.source" class="gx-mi__select">
                <option value="">全部来源</option>
                <option v-for="o in sourceOptions" :key="o" :value="o">{{ o }}</option>
              </select>
            </div>
            <div class="gx-mi__fitem">
              <label>分组</label>
              <select v-model="filter.group" class="gx-mi__select">
                <option value="">全部分组</option>
                <option v-for="o in groupOptions" :key="o" :value="o">{{ o }}</option>
              </select>
            </div>
            <div class="gx-mi__fitem">
              <label>子分组</label>
              <select v-model="filter.subGroup" class="gx-mi__select">
                <option value="">全部子分组</option>
                <option v-for="o in subGroupOptions" :key="o" :value="o">{{ o }}</option>
              </select>
            </div>
            <div class="gx-mi__fitem">
              <label>类目</label>
              <select v-model="filter.category" class="gx-mi__select">
                <option value="">全部类目</option>
                <option v-for="o in categoryOptions" :key="o" :value="o">{{ o }}</option>
              </select>
            </div>
            <div class="gx-mi__fitem">
              <label>子类目</label>
              <select v-model="filter.subCategory" class="gx-mi__select">
                <option value="">全部子类目</option>
                <option v-for="o in subCategoryOptions" :key="o" :value="o">{{ o }}</option>
              </select>
            </div>
          </div>
          <div class="gx-mi__frow">
            <div class="gx-mi__fitem gx-mi__fitem--months">
              <label>上新月份</label>
              <div class="gx-mi__chips">
                <button v-for="m in 12" :key="m" type="button" class="gx-mi__chip" :class="{ 'gx-mi__chip--on': filter.months.includes(m) }" @click="toggleMonth(m)">{{ m }}</button>
              </div>
            </div>
             <div class="gx-mi__fitem gx-mi__fitem--months">
              <label>季节</label>
              <div class="gx-mi__chips">
                <button v-for="s in seasonOptions" :key="s" type="button" class="gx-mi__chip gx-mi__chip--season" :class="{ 'gx-mi__chip--on': filter.seasons.includes(s) }" @click="toggleSeason(s)">{{ s }}</button>
              </div>
            </div>
          </div>
          <div class="gx-mi__frow gx-mi__frow--last">
            <div class="gx-mi__fitem">
              <label>上货状态</label>
              <select v-model="filter.shelfStatus" class="gx-mi__select">
                <option value="">全部</option>
                <option value="up">未上货</option>
                <option value="wait">已上货</option>
                <option value="fail">上货失败</option>
              </select>
            </div>
            <div class="gx-mi__fitem">
              <label>主图生成状态</label>
              <select v-model="filter.genStatus" class="gx-mi__select">
                <option value="">全部</option>
                <option value="none">未生成</option>
                <option value="genning">生成中</option>
                <option value="done">已生成</option>
              </select>
            </div>
            <div class="gx-mi__fitem">
              <label>生成方案</label>
              <select v-model="filter.plan" class="gx-mi__select">
                <option value="">全部方案</option>
                <option v-for="m in modeList" :key="m.key" :value="m.key">{{ m.name }}</option>
              </select>
            </div>
            <div class="gx-mi__fbtns">
              <button class="gx-mi__btn gx-mi__btn--red" @click="handleSearch">查询</button>
              <button class="gx-mi__btn gx-mi__btn--plain" @click="resetFilter">重置</button>
            </div>
          </div>
        </div>

        <!-- 全选行 -->
        <div class="gx-mi__selrow">
          <label class="gx-mi__checkline">
            <span class="gx-mi__check" :class="{ 'gx-mi__check--on': checkState.group }" @click="toggleCheck('group')"></span>本分组全选
          </label>
          <label class="gx-mi__checkline">
            <span class="gx-mi__check" :class="{ 'gx-mi__check--on': checkState.filtered }" @click="toggleCheck('filtered')"></span>筛选结果全选
          </label>
          <label class="gx-mi__checkline gx-mi__checkline--red">
            <span class="gx-mi__check" :class="{ 'gx-mi__check--on': onlyUnready, 'gx-mi__check--red': onlyUnready }" @click="onlyUnready = !onlyUnready">
              <svg v-if="onlyUnready" width="8" height="8" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
            </span>仅未上货
          </label>
          <span class="gx-mi__selcount">已选 <b>{{ selectedGoods.length }}</b> 件商品</span>
        </div>

        <!-- 商品表格 -->
        <div class="gx-mi__table">
          <table border="1">
            <thead>
              <tr>
                <th style="width: 36px"></th>
                <th>商品信息</th>
                <th>来源</th>
                <th>分组</th>
                <th>类目</th>
                <th>销量</th>
                <th>上货状态</th>
                <th>主图生成状态</th>
                <th>产品图(主图)</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in filteredGoods" :key="row.id" :class="{ 'gx-mi__tr--on': isSelected(row) }">
                <td>
                  <span class="gx-mi__check" :class="{ 'gx-mi__check--on': isSelected(row), 'gx-mi__check--red': isSelected(row) }" @click="toggleGoods(row)">
                    <svg v-if="isSelected(row)" width="8" height="8" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
                  </span>
                </td>
                <td>
                  <div class="gx-mi__goods">
                    <span class="gx-mi__goods-icon" :style="{ background: row.iconBg }">{{ row.icon }}</span>
                    <div class="gx-mi__goods-info">
                      <div class="gx-mi__goods-title">{{ row.title }}</div>
                      <div class="gx-mi__goods-code">{{ row.code }}</div>
                    </div>
                  </div>
                </td>
                <td>{{ row.source }}</td>
                <td>{{ row.group }}</td>
                <td>{{ row.category }}</td>
                <td class="gx-mi__mono--num">{{ row.sales }}</td>
                <td><span class="gx-mi__tag" :class="shelfTagClass(row.shelfStatus)">{{ shelfStatusName[row.shelfStatus] }}</span></td>
                <td><span class="gx-mi__tag" :class="genTagClass(row.genStatus)">{{ genStatusName[row.genStatus] }}</span></td>
                <td>
                  <div class="gx-mi__slots">
                    <span v-for="(st, i) in row.imgSlots" :key="i" class="gx-mi__slot" :class="'gx-mi__slot--' + st">
                      <template v-if="st === 'ready'">◔</template>
                      <template v-else-if="st === 'warn'">▲</template>
                      <template v-else>–</template>
                    </span>
                  </div>
                </td>
              </tr>
              <tr v-if="!filteredGoods.length">
                <td colspan="9" class="gx-mi__empty">暂无符合条件的商品</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- 底部操作条 -->
        <div class="gx-mi__footbar">
          <span class="gx-mi__foot-info">已选 <b>{{ selectedGoods.length }}</b> 件，其中 <b class="gx-mi__fc-orange">{{ unreadyCount }}</b> 件未生成主图</span>
          <button class="gx-mi__btn gx-mi__btn--red gx-mi__btn--lg" :disabled="!selectedGoods.length" @click="goStep(2)">下一步 · 选择生成方式 →</button>
        </div>
      </div>

      <!-- ───────── 步骤2：选择生成方式 ───────── -->
      <div v-else-if="currentStep === 2">
        <div class="gx-mi__notice">
          <b>{{ selectedGoods.length }} 件商品进入本轮任务</b>
          <a class="gx-mi__notice-link" @click="goStep(1)">← 重新选择商品</a>
        </div>
        <div class="gx-mi__modes">
          <div v-for="m in modeList" :key="m.key" class="gx-mi__mode" :class="{ 'gx-mi__mode--on': mode === m.key }" @click="mode = m.key">
            <span v-if="mode === m.key" class="gx-mi__mode-check">✓</span>
            <div class="gx-mi__mode-head">
              <span class="gx-mi__mode-icon">{{ m.icon }}</span>
              <span class="gx-mi__mode-name">{{ m.name }}</span>
              <span v-if="m.tag" class="gx-mi__mode-tag">{{ m.tag }}</span>
            </div>
            <div class="gx-mi__mode-desc">{{ m.desc }}</div>
            <ul class="gx-mi__mode-points">
              <li v-for="(p, i) in m.points" :key="i" :class="p.ok === 1 ? 'is-ok' : p.ok === 2 ? 'is-warning' : 'is-no'">
                <span>{{ p.ok === 1 ? '✓' : p.ok === 2 ? '+' : '✗' }}</span>{{ p.t }}
              </li>
            </ul>
          </div>
        </div>
        <div class="gx-mi__footbar">
          <span class="gx-mi__foot-info">已选：<b>{{ currentModeName }}</b> · 每种方式进入不同的配置页</span>
          <div class="gx-mi__foot-btns">
            <button class="gx-mi__btn gx-mi__btn--plain gx-mi__btn--lg" @click="goStep(1)">← 上一步</button>
            <button class="gx-mi__btn gx-mi__btn--red gx-mi__btn--lg" @click="enterConfig">下一步 · 生成配置 →</button>
          </div>
        </div>
      </div>

      <!-- ───────── 步骤3：生成配置 ───────── -->
      <div v-else-if="currentStep === 3">
        <div class="gx-mi__crumb">
          <span><b>{{ configGoods.length }} 件商品</b> · 生成配置</span>
          <span class="gx-mi__crumb-tag">生成方式：{{ currentModeName }}</span>
          <a class="gx-mi__crumb-link" @click="goStep(2)">← 换生成方式</a>
          <a class="gx-mi__crumb-link-t" @click="goStep(1)">← 重新选择商品</a>
          <span class="gx-mi__crumb-right">每个商品独立配置 · 点击展开/折叠</span>
        </div>

        <div v-for="g in configGoods" :key="g.id" class="gx-mi__pcard" :class="{ 'gx-mi__pcard--collapsed': !expandedIds.includes(g.id) }">
          <div class="gx-mi__pcard-head" :class="{'gx-mi__pcard--c':expandedIds.includes(g.id)}" @click="toggleCard(g.id)">
            <div class="gx-mi__pcard-content">
                <span class="gx-mi__goods-icon" :style="{ background: g.iconBg }">{{ g.icon }}</span>
                <div>
                    <div class="gx-mi__pcard-info">
                        <span class="gx-mi__code">{{ g.code }}</span>
                        <span class="gx-mi__tag" :class="mode === 'custom' ? 'gx-mi__tag--blue' : 'gx-mi__tag--gray'">{{ g.group.replace('-', '') }}</span>
                        <span class="gx-mi__tag" :class="mode === 'custom' ? 'gx-mi__tag--blue-line' : 'gx-mi__tag--red'">{{ currentModeName }}</span>
                    </div>
                    <div class="gx-mi__pcard-title">{{ g.title }}</div>
                </div>
            </div>
            <span class="gx-mi__pcard-fold">{{ expandedIds.includes(g.id) ? '⌃' : '⌄' }}</span>
          </div>

          <div v-show="expandedIds.includes(g.id)" class="gx-mi__pcard-body">
            <!-- 产品图 + 参考来源 -->
            <div class="gx-mi__cfg-cols">
              <div class="gx-mi__cfg-col">
                <div class="gx-mi__cfg-title">① 产品图</div>
                <div class="gx-mi__imgtabs">
                  <span v-for="(t, ti) in ['主图', 'SKU图', '白底图', '详情页']" :key="t" class="gx-mi__imgtab" :class="{ 'gx-mi__imgtab--on': ti === 0 }">{{ t }}</span>
                </div>
                <div class="gx-mi__imgslots">
                  <span v-for="n in 4" :key="'p-' + n" class="gx-mi__imgslot" :class="{ 'gx-mi__imgslot--pick': n <= 2 }">
                    <span class="gx-mi__imgslot-badge">{{ n }}</span>图
                  </span>
                  <span class="gx-mi__imgslot gx-mi__imgslot--empty">–</span>
                  <span class="gx-mi__imgslot gx-mi__imgslot--empty">–</span>
                  <span class="gx-mi__imgslot gx-mi__imgslot--add">＋<br />上传</span>
                </div>
                <div class="gx-mi__cfg-foot">已选 <b class="gx-mi__fc-red">2</b>/3 张</div>
              </div>

              <!-- 参考来源（复刻/参考风格模式） -->
              <div v-if="mode !== 'custom'" class="gx-mi__cfg-col">
                <div class="gx-mi__cfg-title">② 参考来源 · 复刻模板库 <a class="gx-mi__cfg-more">全部→</a></div>
                <div class="gx-mi__tpls">
                  <span v-for="(t, ti) in templates" :key="t" class="gx-mi__tpl" :class="{ 'gx-mi__tpl--on': ti === 0 }">
                    <span class="gx-mi__tpl-ico">{{ tplIcons[ti] }}</span>
                    <span class="gx-mi__tpl-name">{{ t }}</span>
                  </span>
                </div>
                <div class="gx-mi__refarea">
                  <div class="gx-mi__refhint">参考图（可选）</div>
                  <div class="gx-mi__refslot">
                    <span class="gx-mi__imgslot gx-mi__imgslot--add">＋<br />上传</span>
                    <span class="gx-mi__refhint">可与模板同时使用</span>
                  </div>
                  
                </div>
              </div>

              <!-- 提示词（自定义生成模式） -->
              <div v-else class="gx-mi__cfg-col gx-mi__cfg-col--prompt">
                <div class="gx-mi__cfg-title">② 提示词</div>
                <textarea
                  v-model="customPromptMap[g.id]"
                  class="gx-mi__prompt-textarea"
                  placeholder="描述你想要的画面风格、场景、构图、光线..."
                ></textarea>
                <div class="gx-mi__cfg-note">叠加系统提示词</div>
                <div class="gx-mi__prompt-opts">
                  <label class="gx-mi__checkline">
                    <span
                      class="gx-mi__check gx-mi__check--blue"
                      :class="{ 'gx-mi__check--on': (promptOptMap[g.id] || {}).title }"
                      @click="togglePromptOpt(g.id, 'title')"
                    ></span>商品标题
                  </label>
                  <label class="gx-mi__checkline">
                    <span
                      class="gx-mi__check gx-mi__check--blue"
                      :class="{ 'gx-mi__check--on': (promptOptMap[g.id] || {}).attr }"
                      @click="togglePromptOpt(g.id, 'attr')"
                    ></span>属性参数
                  </label>
                  <label class="gx-mi__checkline">
                    <span
                      class="gx-mi__check gx-mi__check--blue"
                      :class="{ 'gx-mi__check--on': (promptOptMap[g.id] || {}).category }"
                      @click="togglePromptOpt(g.id, 'category')"
                    ></span>类目风格
                  </label>
                </div>
              </div>
            </div>

            <!-- 模特人脸 -->
            <div class="gx-mi__cfg-row gx-mi__cfg-row--block">
              <div class="gx-mi__cfg-rowhead">
                <div class="gx-mi__cfg-title">③ 模特人脸（选配）</div>
                <label class="gx-mi__switchline">
                  {{ faceOnMap[g.id] ? '已开启模特人脸' : '未开启 · 仅生成产品图' }}
                  <span class="gx-mi__switch" :class="{ 'gx-mi__switch--on': faceOnMap[g.id] }" @click.stop="toggleFace(g.id)"><i></i></span>
                </label>
              </div>

              <!-- 开启后展开模特选择 -->
              <div v-if="faceOnMap[g.id]" class="gx-mi__face">
                <div class="gx-mi__face-tabs">
                  <button
                    type="button"
                    class="gx-mi__face-tab"
                    :class="{ 'gx-mi__face-tab--on': (faceTabMap[g.id] || 'ai') === 'ai' }"
                    @click="faceTabMap[g.id] = 'ai'"
                  >
                    <span class="gx-mi__ft-ico gx-mi__ft-ico--red">👤</span>AI模特库
                  </button>
                  <button
                    type="button"
                    class="gx-mi__face-tab"
                    :class="{ 'gx-mi__face-tab--on': faceTabMap[g.id] === 'custom' }"
                    @click="faceTabMap[g.id] = 'custom'"
                  >
                    <span class="gx-mi__ft-ico gx-mi__ft-ico--gold">✨</span>自定义模特
                  </button>
                  <button
                    type="button"
                    class="gx-mi__face-tab"
                    :class="{ 'gx-mi__face-tab--on': faceTabMap[g.id] === 'upload' }"
                    @click="faceTabMap[g.id] = 'upload'"
                  >
                    <span class="gx-mi__ft-ico gx-mi__ft-ico--red">📤</span>上传人脸
                  </button>
                </div>

                <!-- AI模特库 -->
                <template v-if="(faceTabMap[g.id] || 'ai') === 'ai'">
                  <div class="gx-mi__face-grid">
                    <div
                      v-for="f in faceModels"
                      :key="f.id"
                      class="gx-mi__face-card"
                      :class="{ 'gx-mi__face-card--on': faceSelMap[g.id] === f.id }"
                      @click="faceSelMap[g.id] = f.id"
                    >
                      <span class="gx-mi__face-ico">{{ f.icon }}</span>
                      <span class="gx-mi__face-name">{{ f.name }}</span>
                    </div>
                  </div>
                  <div class="gx-mi__face-tip">💡 全部模特均由AI生成，不涉及真实人物肖像权问题</div>
                </template>

                <!-- 自定义模特 -->
                <template v-else-if="faceTabMap[g.id] === 'custom'">
                  <textarea
                    v-model="faceCustomMap[g.id]"
                    class="gx-mi__face-textarea"
                    placeholder="25-30岁亚洲女性、气质知性、微笑状态..."
                  ></textarea>
                  <div class="gx-mi__face-tip">💡 AI将对拍摄模特生成AI风格模特，不存在肖像权问题</div>
                </template>

                <!-- 上传人脸 -->
                <template v-else>
                  <div class="gx-mi__face-uploadbox">
                    <span class="gx-mi__face-uploadico">⬆</span>
                    <span class="gx-mi__face-uploadtxt">上传人脸照片</span>
                  </div>
                  <div class="gx-mi__face-tip gx-mi__face-tip--red">⚠ 上传即代表你确认拥有该人脸的合法使用权利（本人需已获授权）</div>
                </template>
              </div>
            </div>

            <!-- 提示词 / 照片文案（复刻、参考风格模式；自定义模式已并入②提示词） -->
            <template v-if="mode !== 'custom'">
              <!-- 提示词 -->
              <div class="gx-mi__cfg-row gx-mi__cfg-row--block">
                <div class="gx-mi__cfg-title">④ 提示词</div>
                <div class="gx-mi__prompt-tags">
                  <span v-for="t in modePromptTags" :key="t" class="gx-mi__ptag">{{ t }}</span>
                </div>
                <div class="gx-mi__prompt-line">
                  <label>补充说明：</label>
                  <input v-model="promptExtraMap[g.id]" class="gx-mi__input gx-mi__input--flex" placeholder="例如「突出面料质感，浅色背景」" />
                </div>
                <div class="gx-mi__cfg-note">系统内置提示词已按所选模板自动配置</div>
              </div>

              <!-- 照片文案 -->
              <div class="gx-mi__cfg-row gx-mi__cfg-row--block">
                <div class="gx-mi__cfg-title">⑤ 照片文案</div>
                <div class="gx-mi__copyopts">
                  <label class="gx-mi__copyopt" :class="{ 'gx-mi__copyopt--on': copyMap[g.id] === 'keep' }" @click="copyMap[g.id] = 'keep'">
                    <span class="gx-mi__radio" :class="{ 'gx-mi__radio--on': copyMap[g.id] === 'keep' }"></span>
                    <span class="gx-mi__copyopt-body">
                      <b>保留参考图文案（不更改）</b>
                      <i>直接复用参考图自带的文字，适合已有成熟文案的情况</i>
                    </span>
                  </label>
                  <label class="gx-mi__copyopt" :class="{ 'gx-mi__copyopt--on': copyMap[g.id] === 'new' }" @click="copyMap[g.id] = 'new'">
                    <span class="gx-mi__radio" :class="{ 'gx-mi__radio--on': copyMap[g.id] === 'new' }"></span>
                    <span class="gx-mi__copyopt-body">
                      <b>按产品属性卖点生成新文案</b>
                      <i>AI根据商品标题、类目、属性等数据重新生成贴合卖点的文案</i>
                    </span>
                  </label>
                </div>
              </div>
            </template>
          </div>
        </div>

        <div class="gx-mi__footbar">
          <span class="gx-mi__foot-info">共 <b>{{ configGoods.length }}</b> 件商品 · 预计生成 <b class="gx-mi__fc-red">{{ expectedImages }}</b> 张主图 · 消耗算力约 <b class="gx-mi__fc-orange">{{ expectedImages }} ⚡</b></span>
          <div class="gx-mi__foot-btns">
            <button class="gx-mi__btn gx-mi__btn--plain gx-mi__btn--lg" @click="goStep(2)">← 上一步</button>
            <button class="gx-mi__btn gx-mi__btn--plain gx-mi__btn--lg" @click="saveTemplate">存为常用模板</button>
            <button class="gx-mi__btn gx-mi__btn--red gx-mi__btn--lg" @click="publishTask">🔥 发布任务</button>
          </div>
        </div>
      </div>

      <!-- ───────── 步骤4：发布完成 ───────── -->
      <div v-else class="gx-mi__done">
        <span class="gx-mi__done-icon">✅</span>
        <div class="gx-mi__done-title">任务发布成功</div>
        <div class="gx-mi__done-desc">AI 正在生成主图，可在「生成记录」中查看进度</div>
        <button class="gx-mi__btn gx-mi__btn--red gx-mi__btn--lg" @click="mainTab = 'record'">查看生成记录 →</button>
      </div>
    </template>

    <!-- ═══════════════════════════════════════ -->
    <!-- Tab2：生成记录                          -->
    <!-- ═══════════════════════════════════════ -->
    <template v-else-if="mainTab === 'record'">
      <div class="gx-mi__stats">
        <div v-for="s in stats" :key="s.label" class="gx-mi__stat" :style="{ borderColor: statsTab===s.id? s.color: '', backgroundColor: statsTab===s.id? s.backgroundColor: '' }" @click="statsTab=s.id">  
          <span class="gx-mi__stat-num" :style="{ color: s.color }">{{ s.value }}</span>
          <span class="gx-mi__stat-label">{{ s.label }}</span>
        </div>
        <span class="gx-mi__stats-right">本页任务共消耗 <b class="gx-mi__fc-red-t">148</b> 算力</span>
      </div>

      <div class="gx-mi__table">
        <table border="1">
          <thead>
            <tr>
              <th>任务编号</th>
              <th>发布时间</th>
              <th>生成模式</th>
              <th>商品数</th>
              <th>进度</th>
              <th>消耗算力</th>
              <th>状态</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="t in taskList">
              <tr :key="t.id" class="gx-mi__tr-task">
                <td><a class="gx-mi__link-cyan">{{ t.task_no }}</a></td>
                <td class="gx-mi__mono">{{ t.time }}</td>
                <td><span class="gx-mi__tag" :class="'gx-mi__tag--' + t.modeType">{{ t.mode }}</span></td>
                <td>
                  <div class="gx-mi__td-stack"><b>{{ t.goodsCount }} 件</b><i v-if="t.failCount" class="gx-mi__fc-red">{{ t.failCount }}件生成失败</i></div>
                </td>
                <td>
                  <div class="gx-mi__progress">
                    <div class="gx-mi__progress-bar"><div class="gx-mi__progress-in" :style="{ width: t.progress + '%' }"></div></div>
                    <span class="gx-mi__progress-txt">{{ t.done }}/{{ t.total }}<i v-if="t.failCount" class="gx-mi__fc-red"> · 失败{{ t.failCount }}</i></span>
                  </div>
                </td>
                <td class="gx-mi__mono">{{ t.cost }}⚡ · {{ t.failCost }}算力/张</td>
                <td><span class="gx-mi__tag" :class="'gx-mi__tag--' + t.statusType">{{ t.status }}</span></td>
                <td>
                  <div class="gx-mi__ops">
                    <a class="gx-mi__op-link" @click="toggleTaskDetail(t)">{{ expandedTask === t.id ? '收起明细' : '任务明细' }}</a>
                    <a v-if="t.failCount" class="gx-mi__op-link gx-mi__op-link--red">重试失败</a>
                    <a class="gx-mi__op-link gx-mi__op-link--red">删除</a>
                  </div>
                </td>
              </tr>
              <tr v-if="expandedTask === t.id" :key="'d-' + t.id" class="gx-mi__tr-detail">
                <td colspan="8">
                  <div class="gx-mi__detail-head">任务明细 · 每件商品用参考来源与产品图</div>
                  <div v-for="(d, di) in t.details" :key="di" class="gx-mi__detail-item">
                    <div>
                    <span class="gx-mi__goods-icon" :style="{ background: d.iconBg }">{{ d.icon }}</span>
                    <span class="gx-mi__pcard-code gx-mi__tag--right">{{ d.code }}</span>
                    <span class="gx-mi__detail-title" style="margin-left: 24px;">{{ d.title }}</span>
                    <span class="gx-mi__detail-meta gx-mi__tag--right">参考：{{ d.ref }}</span>
                    </div>
                    <div>
                    <span class="gx-mi__detail-meta">产品图：{{ d.imgs }}</span>
                    <span class="gx-mi__tag gx-mi__tag--right" :class="d.ok ? 'gx-mi__tag--green' : 'gx-mi__tag--orange'">{{ d.ok ? '已完成' : '部分失败' }}</span>
                    </div>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </template>

    <!-- ═══════════════════════════════════════ -->
    <!-- Tab3：模板管理                          -->
    <!-- ═══════════════════════════════════════ -->
    <template v-else>
      <!-- 工具行 -->
      <div class="gx-mi__tplbar">
        <div class="gx-mi__tplfilters">
          <button
            v-for="f in tplFilters"
            :key="f.key"
            type="button"
            class="gx-mi__tplfilter"
            :class="{ 'gx-mi__tplfilter--on': tplFilter === f.key }"
            @click="tplFilter = f.key"
          >{{ f.label }}</button>
        </div>
        <input v-model="tplKeyword" class="gx-mi__input gx-mi__tplsearch" placeholder="搜索名称/标签..." />
        <div class="gx-mi__tplbar-right">
          <button class="gx-mi__btn gx-mi__btn--plain" @click="handleImport">📥 导入</button>
          <button class="gx-mi__btn gx-mi__btn--red" @click="openCreateTpl">＋ 新建主图模板</button>
        </div>
      </div>

      <!-- 统计卡 -->
      <div class="gx-mi__tplstats">
        <div v-for="s in tplStatList" :key="s.label" class="gx-mi__tplstat">
          <span class="gx-mi__tplstat-num" :style="{ color: s.color }">{{ s.value }}</span>
          <span class="gx-mi__tplstat-label">{{ s.label }}</span>
        </div>
      </div>

      <!-- 模板卡片 -->
      <div class="gx-mi__tplgrid">
        <div v-for="t in filteredTplList" :key="t.id" class="gx-mi__tplcard">
          <div class="gx-mi__tplcard-head" :class="'gx-mi__tplcard-head--' + t.type">
            <span class="gx-mi__tplcard-ico">{{ t.icon }}</span>
            <span class="gx-mi__tplcard-badge" :class="'gx-mi__tplcard-badge--' + t.type">{{ typeName[t.type] }}</span>
          </div>
          <div class="gx-mi__tplcard-body">
            <div class="gx-mi__tplcard-name">{{ t.name }}</div>
            <div class="gx-mi__tplcard-tags">
              <span v-for="(tag, ti) in t.tags" :key="ti" class="gx-mi__ttag" :class="{ 'gx-mi__ttag--fixed': tag.fixed }">{{ tag.t }}</span>
            </div>
            <div class="gx-mi__tplcard-info">
                <div class="gx-mi__tplcard-info-l">
                    <div class="gx-mi__tplcard-info-l-item">自定义</div>
                </div>
                <span class="gx-mi__tplcard-usage">用{{ t.usageCount }}次 · {{ t.updatedAt }}</span>
            </div>
            <div class="gx-mi__tplcard-foot">
              <div class="gx-mi__tplcard-ops">
                <button class="gx-mi__btn gx-mi__btn--red gx-mi__btn--xs" @click="useTemplate(t)">使用模板</button>
                <button class="gx-mi__btn gx-mi__btn--plain gx-mi__btn--xs" @click="editTemplate(t)">编辑</button>
                <button class="gx-mi__btn gx-mi__btn--plain gx-mi__btn--xs" @click="copyTemplate(t)">复制</button>
              </div>
              <a class="gx-mi__tplcard-del" @click="deleteTemplate(t)">删除</a>
            </div>
          </div>
        </div>

        <!-- 新建卡片 -->
        <div class="gx-mi__tplcard gx-mi__tplcard--add" @click="openCreateTpl">
          <span class="gx-mi__tplcard-addico">＋</span>
          <span class="gx-mi__tplcard-addname">新建主图模板</span>
          <span class="gx-mi__tplcard-adddesc">定义每张图的角色与类型，一键应用到全部商品</span>
        </div>
      </div>

      <!-- 新建/编辑模板弹窗 -->
      <div v-if="tplDialogVisible" class="gx-mi__modal-mask" @click.self="closeTplDialog">
        <div class="gx-mi__modal">
          <div class="gx-mi__modal-head">
            <span class="gx-mi__modal-title">{{ tplForm.id ? '编辑主图模板' : '新建主图模板' }}</span>
            <span class="gx-mi__modal-close" @click="closeTplDialog">✕</span>
          </div>
          <div class="gx-mi__modal-body">
            <div class="gx-mi__mfield">
              <label>模板名称</label>
              <input v-model="tplForm.name" class="gx-mi__input gx-mi__minput" placeholder="例：夏日爆款五图" />
            </div>
            <div class="gx-mi__mfield">
              <label>适用类目标签</label>
              <input v-model="tplForm.categories" class="gx-mi__input gx-mi__minput" placeholder="服装，箱包（逗号分隔）" />
            </div>
            <div class="gx-mi__mfield">
              <label>生成方式</label>
              <div class="gx-mi__mradios">
                <label v-for="m in modeList" :key="m.key" style="display: flex;" class="gx-mi__mradio" @click="tplForm.mode = m.key">
                  <span class="gx-mi__radio" :class="{ 'gx-mi__radio--on': tplForm.mode === m.key }"></span>
                  {{ m.name }}
                </label>
              </div>
            </div>
            <div class="gx-mi__mtip">💡 模板创建后可在生成配置·主图配置中选择应用，支持定义每张图为"生成图"或"固定图"。</div>
          </div>
          <div class="gx-mi__modal-foot">
            <button class="gx-mi__btn gx-mi__btn--plain gx-mi__btn--lg" @click="closeTplDialog">取消</button>
            <button class="gx-mi__btn gx-mi__btn--red gx-mi__btn--lg" @click="submitTpl">创建模板</button>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'NewMainImagePage',
  data() {
    return {
      mainTab: 'task', // task | record | tpl
      currentStep: 1,
      steps: [
        { n: 1, label: '① 选择商品' },
        { n: 2, label: '② 选择生成方式' },
        { n: 3, label: '③ 生成配置' },
        { n: 4, label: '④ 发布任务' }
      ],
      // 筛选
      filter: {
        keyword: '', sourceId: '', platformId: '',
        source: '', group: '', subGroup: '', category: '', subCategory: '',
        months: [], seasons: [],
        shelfStatus: '', genStatus: '', plan: ''
      },
      sourceOptions: ['1688', '淘宝', '拼多多'],
      groupOptions: ['官方-A', '官方-B', '万能-A'],
      subGroupOptions: ['夏季新款', '清仓款'],
      categoryOptions: ['男装', '女装', '运动鞋服'],
      subCategoryOptions: ['男装/T恤', '女装/连衣裙', '运动鞋/跑步鞋'],
      seasonOptions: ['春', '夏', '秋', '冬'],
      checkState: { group: false, filtered: false },
      onlyUnready: true,
      shelfStatusName: { up: '未上货', wait: '已上货', fail: '上货失败' },
      genStatusName: { none: '未生成', done: '已生成' },
      // 商品
      goodsList: [
        { id: 1, code: 'CS-011', title: '男士休闲短袖T恤夏季清凉宽松百搭纯棉上衣', icon: '👕', iconBg: '#E8F1FF', source: '1688', group: '官方-A', category: '男装/T恤', sales: '1,482', shelfStatus: 'up', genStatus: 'none', shopTag: '已铺货', imgSlots: ['ready', 'ready', 'empty', 'empty'] },
        { id: 2, code: 'CS-012', title: '女士连衣裙法式收腰显瘦长裙夏季新品气质裙', icon: '👗', iconBg: '#FDE8F0', source: '淘宝', group: '官方-B', category: '女装/连衣裙', sales: '3,247', shelfStatus: 'up', genStatus: 'done', shopTag: '已铺货', imgSlots: ['warn', 'warn', 'empty', 'empty'] },
        { id: 3, code: 'CS-013', title: '运动鞋男款轻便透气跑步鞋2026新款软底慢跑鞋', icon: '👟', iconBg: '#EDE8FD', source: '1688', group: '万能-A', category: '运动鞋/跑步鞋', sales: '--', shelfStatus: 'wait', genStatus: 'none', shopTag: '未上架', imgSlots: ['ready', 'ready', 'empty', 'empty'] },
        { id: 4, code: 'CS-014', title: '双肩包大容量学生书包男女通用旅行背包', icon: '🎒', iconBg: '#FDEEDE', source: '拼多多', group: '官方-B', category: '箱包/双肩包', sales: '892', shelfStatus: 'up', genStatus: 'done', shopTag: '已铺货', imgSlots: ['warn', 'warn', 'empty', 'empty'] },
        { id: 5, code: 'CS-015', title: '男士冲锋衣三合一防风防水户外登山服外套', icon: '🧥', iconBg: '#FEF5E4', source: '1688', group: '官方-A', category: '男装/外套', sales: '--', shelfStatus: 'fail', genStatus: 'none', shopTag: '上架失败', imgSlots: ['warn', 'warn', 'empty', 'empty'] }
      ],
      selectedIds: [1, 2, 3],
      // 生成方式
      mode: 'copy',
      modeList: [
        {
          key: 'copy', name: '高度复刻', icon: '🔁', tag: '推荐',
          desc: '精准还原参考图的构图/光影/风格',
          points: [
            { t: '产品图：库内自选1-3张/上传', ok: 1 },
            { t: '风格来源：复制模板/上传参考图', ok: 1 },
            { t: '提示词：系统内置复刻规则', ok: 1 },
            { t: '补充说明（选填一句过）', ok: 2 }
          ]
        },
        {
          key: 'style', name: '参考风格', icon: '🎨', tag: '',
          desc: '提取参考图的风格调性重新创作',
          points: [
            { t: '产品图：库内自选1-3张/上传', ok: 1 },
            { t: '风格来源：风格模板/上传参考图', ok: 1 },
            { t: '提示词：系统内置风格规则', ok: 1 },
            { t: '补充说明（选填）', ok: 2 }
          ]
        },
        {
          key: 'custom', name: '自定义生成', icon: '✍️', tag: '',
          desc: '无需参考图，用提示词自由描述画面',
          points: [
            { t: '产品图：库内自选1-3张/上传', ok: 1 },
            { t: '提示词：店主要求+系统配置', ok: 1 },
            { t: '无参考来源', ok: 3 },
            { t: '单图可单独配置提示词', ok: 2 }
          ]
        }
      ],
      // 步骤3
      expandedIds: [1, 2, 3],
      templates: ['夏日白底爆款A', '清凉场景B', '高级感C', '潮流拼贴D', '简约时尚E', '户外运动F'],
      tplIcons: ['✷', '🌊', '✦', '❀', '▢', '🏃'],
      faceOnMap: {},
      faceTabMap: {},
      faceSelMap: {},
      faceCustomMap: {},
      faceModels: [
        { id: 'A', name: '知性女模A', icon: '👩' },
        { id: 'B', name: '阳光男模B', icon: '👨' },
        { id: 'C', name: '年轻潮流C', icon: '🧑' },
        { id: 'D', name: '成熟男性D', icon: '🧔' }
      ],
      copyMap: { 1: 'keep', 2: 'keep', 3: 'keep' },
      promptExtraMap: { 1: '', 2: '', 3: '' },
      customPromptMap: {},
      promptOptMap: {},
      // 生成记录
      expandedTask: 1,
      taskList: [
        {
          id: 1, task_no: 'RW2026083101', time: '2026-08-31 14:22', mode: '高度复刻', modeType: 'red',
          goodsCount: 3, failCount: 1, done: 2, total: 3, progress: 67, cost: '36', failCost: 12,
          status: '部分失败', statusType: 'orange',
          details: [
            { code: 'CS-011', icon: '👕', iconBg: '#E8F1FF', title: '男士T恤', ref: '模板「夏日白底爆款A」', imgs: '主图1、白底图1', ok: false },
            { code: 'CS-012', icon: '👗', iconBg: '#FDE8F0', title: '法式连衣裙', ref: '上传参考图（单张）', imgs: '主图2', ok: true },
            { code: 'CS-013', icon: '👟', iconBg: '#EDE8FD', title: '跑步鞋', ref: '模板「夏日白底爆款A」', imgs: '主图1', ok: true }
          ]
        },
        { id: 2, task_no: 'RW2026083102', time: '2026-08-31 13:05', mode: '参考风格', modeType: 'yellow', goodsCount: 2, failCount: 0, done: 2, total: 2, progress: 100, cost: '已扣 24', failCost: 0, status: '生成中', statusType: 'blue', details: [] },
        { id: 3, task_no: 'RW2026083103', time: '2026-08-31 11:48', mode: '自定义', modeType: 'blue', goodsCount: 1, failCount: 0, done: 1, total: 1, progress: 100, cost: '27 算力（已扣）', failCost: 0, status: '已完成', statusType: 'green', details: [] },
        { id: 4, task_no: 'RW2026083104', time: '2026-08-31 10:30', mode: '高度复刻', modeType: 'red', goodsCount: 1, failCount: 0, done: 1, total: 1, progress: 100, cost: '已扣 12', failCost: 0, status: '生成中', statusType: 'blue', details: [] }
      ],
      // 模板管理
      tplFilter: 'all',
      tplKeyword: '',
      tplFilters: [
        { key: 'all', label: '全部' },
        { key: 'copy', label: '复刻模板' },
        { key: 'style', label: '风格模板' },
        { key: 'custom', label: '自定义模板' }
      ],
      typeName: { copy: '高度复刻', style: '参考风格', custom: '自定义' },
      tplDialogVisible: false,
      tplForm: { id: null, name: '', categories: '', mode: 'copy' },
      statsTab:0,
      templateList: [
        {
          id: 1, name: '白底爆款五图', type: 'copy', icon: '☀️', usageCount: 3, updatedAt: '08-28',
          tags: [{ t: '产品图素材×1' }, { t: '品牌效果（固定）', fixed: true }, { t: '模特展示×1' }, { t: '工艺细节（固定）', fixed: true }, { t: '模特展示×1' }]
        },
        {
          id: 2, name: '清凉夏日三图', type: 'style', icon: '🌊', usageCount: 4, updatedAt: '08-22',
          tags: [{ t: '产品图×1' }, { t: '清凉场景×1' }, { t: '模特展示×1' }]
        },
        {
          id: 3, name: '品牌视觉三图', type: 'copy', icon: '🎯', usageCount: 6, updatedAt: '08-18',
          tags: [{ t: '爆款主图×1' }, { t: '品牌效果（固定）', fixed: true }, { t: '产品细节×1' }]
        },
        {
          id: 4, name: '户外运动四图', type: 'copy', icon: '🏃', usageCount: 6, updatedAt: '08-10',
          tags: [{ t: '白底图×1' }, { t: '品牌logo（固定）', fixed: true }, { t: '户外场景×1' }, { t: '模特展示×1' }]
        },
        {
          id: 5, name: '极简二图', type: 'style', icon: '⬜', usageCount: 4, updatedAt: '08-05',
          tags: [{ t: '产品图白底×1' }, { t: '白底展示×1' }, { t: '排版模板×1' }]
        },
        {
          id: 6, name: '自定义五图', type: 'custom', icon: '✍️', usageCount: 2, updatedAt: '08-02',
          tags: [{ t: '图1×1' }, { t: '图2×1' }, { t: '图3×1' }, { t: '图4×1' }, { t: '图5×1' }]
        }
      ]
    }
  },
  computed: {
    filteredGoods() {
      const kw = (this.filter.keyword || '').trim()
      return this.goodsList.filter((g) => {
        if (kw && !(g.title.includes(kw) || g.code.toLowerCase().includes(kw.toLowerCase()))) return false
        if (this.filter.source && g.source !== this.filter.source) return false
        if (this.filter.shelfStatus && g.shelfStatus !== this.filter.shelfStatus) return false
        if (this.filter.genStatus && g.genStatus !== this.filter.genStatus) return false
        return true
      })
    },
    selectedGoods() {
      return this.goodsList.filter((g) => this.selectedIds.includes(g.id))
    },
    unreadyCount() {
      return this.selectedGoods.filter((g) => g.genStatus === 'none').length
    },
    configGoods() {
      return this.selectedGoods
    },
    expectedImages() {
      return this.selectedGoods.length * 5
    },
    currentModeName() {
      const m = this.modeList.find((x) => x.key === this.mode)
      return m ? m.name : ''
    },
    modePromptTags() {
      if (this.mode === 'copy') return ['#高度复刻规则 · 系统内置', '#商品构图 · 系统内置', '#模特参数 · 系统内置']
      if (this.mode === 'style') return ['#风格复刻规则 · 风格内置', '#商品构图 · 系统内置', '#模特参数 · 系统内置']
      return ['#店主要求规则 · 店主内置', '#商品品类 · 系统内置', '#属性参数 · 系统内置']
    },
    stats() {
      return [
        { id:0,label: '全部任务', value: 4, color: '#1f2937' ,backgroundColor: 'rgb(255, 255, 255)' },
        { id:1,label: '生成中', value: 2, color: '#409EFF' ,backgroundColor: 'rgb(230, 244, 255)' },
        { id:2,label: '已完成', value: 1, color: '#67C23A' ,backgroundColor: 'rgb(246, 255, 237)' },
        { id:3,label: '积分失败', value: 1, color: '#E6A23C' ,backgroundColor: 'rgb(255, 247, 230)' }
      ]
    },
    filteredTplList() {
      const kw = (this.tplKeyword || '').trim()
      return this.templateList.filter((t) => {
        if (this.tplFilter !== 'all' && t.type !== this.tplFilter) return false
        if (kw) {
          const inTags = t.tags.some((tag) => tag.t.includes(kw))
          if (!(t.name.includes(kw) || inTags)) return false
        }
        return true
      })
    },
    tplStatList() {
      const count = (type) => this.templateList.filter((t) => t.type === type).length
      return [
        { label: '全部模板', value: this.templateList.length, color: '#1f2937' },
        { label: '高度复刻', value: count('copy'), color: '#C8443C' },
        { label: '参考风格', value: count('style'), color: '#C99A1B' },
        { label: '自定义', value: count('custom'), color: '#409EFF' },
        { label: '累计使用', value: this.templateList.reduce((s, t) => s + t.usageCount, 0), color: '#67C23A' }
      ]
    }
  },
  methods: {
    shelfTagClass(s) {
      return s === 'up' ? 'gx-mi__tag--orange' : s === 'fail' ? 'gx-mi__tag--red' : 'gx-mi__tag--green'
    },
    genTagClass(s) {
      return s === 'done' ? 'gx-mi__tag--green' : 'gx-mi__tag--gray'
    },
    statsTabClass(s) {
      return s.id === this.statsTab ? 'gx-mi__stat--on' : ''
    },
    toggleStatsTab(s) {
      this.statsTab = s.id
    },
    toggleMonth(m) {
      const i = this.filter.months.indexOf(m)
      if (i >= 0) this.filter.months.splice(i, 1)
      else this.filter.months.push(m)
    },
    toggleSeason(s) {
      const i = this.filter.seasons.indexOf(s)
      if (i >= 0) this.filter.seasons.splice(i, 1)
      else this.filter.seasons.push(s)
    },
    handleSearch() {
      this.$message && this.$message.success('已按条件筛选')
    },
    resetFilter() {
      this.filter = {
        keyword: '', sourceId: '', platformId: '',
        source: '', group: '', subGroup: '', category: '', subCategory: '',
        months: [], seasons: [],
        shelfStatus: '', genStatus: '', plan: ''
      }
    },
    isSelected(row) {
      return this.selectedIds.includes(row.id)
    },
    toggleGoods(row) {
      const i = this.selectedIds.indexOf(row.id)
      if (i >= 0) this.selectedIds.splice(i, 1)
      else this.selectedIds.push(row.id)
    },
    toggleCheck(type) {
      this.checkState[type] = !this.checkState[type]
      if (type === 'group') {
        this.selectedIds = this.checkState.group ? this.goodsList.map((g) => g.id) : []
        this.checkState.filtered = false
      } else {
        this.selectedIds = this.checkState.filtered ? this.filteredGoods.map((g) => g.id) : []
        this.checkState.group = false
      }
    },
    stepClass(n) {
      return {
        'gx-mi__step--on': n === this.currentStep,
        'gx-mi__step--done': n < this.currentStep
      }
    },
    goStep(n) {
      this.currentStep = n
    },
    enterConfig() {
      // 初始化每个商品的配置默认值
      this.selectedGoods.forEach((g) => {
        if (!this.copyMap[g.id]) this.$set(this.copyMap, g.id, 'keep')
        if (!this.promptExtraMap[g.id]) this.$set(this.promptExtraMap, g.id, '')
        if (this.faceOnMap[g.id] === undefined) this.$set(this.faceOnMap, g.id, false)
        if (!this.faceTabMap[g.id]) this.$set(this.faceTabMap, g.id, 'ai')
        if (!this.faceSelMap[g.id]) this.$set(this.faceSelMap, g.id, 'A')
        if (this.faceCustomMap[g.id] === undefined) this.$set(this.faceCustomMap, g.id, '')
        if (this.customPromptMap[g.id] === undefined) this.$set(this.customPromptMap, g.id, '')
        if (!this.promptOptMap[g.id]) this.$set(this.promptOptMap, g.id, { title: true, attr: true, category: false })
      })
      this.expandedIds = this.selectedGoods.map((g) => g.id)
      this.currentStep = 3
      window.scrollTo && window.scrollTo(0, 0)
    },
    toggleCard(id) {
      const i = this.expandedIds.indexOf(id)
      if (i >= 0) this.expandedIds.splice(i, 1)
      else this.expandedIds.push(id)
    },
    toggleFace(id) {
      const on = !this.faceOnMap[id]
      this.$set(this.faceOnMap, id, on)
      if (on) {
        if (!this.faceTabMap[id]) this.$set(this.faceTabMap, id, 'ai')
        if (!this.faceSelMap[id]) this.$set(this.faceSelMap, id, 'A')
      }
    },
    togglePromptOpt(id, key) {
      const opts = this.promptOptMap[id] || { title: true, attr: true, category: false }
      this.$set(this.promptOptMap, id, Object.assign({}, opts, { [key]: !opts[key] }))
    },
    saveTemplate() {
      this.$message && this.$message.success('已存为常用模板')
    },
    publishTask() {
      this.$message && this.$message.success('任务发布成功，AI 开始生成主图')
      this.currentStep = 4
      window.scrollTo && window.scrollTo(0, 0)
    },
    toggleTaskDetail(t) {
      this.expandedTask = this.expandedTask === t.id ? null : t.id
    },
    // ── 模板管理 ──
    openCreateTpl() {
      this.tplForm = { id: null, name: '', categories: '', mode: 'copy' }
      this.tplDialogVisible = true
    },
    editTemplate(t) {
      this.tplForm = { id: t.id, name: t.name, categories: t.categoryText || '', mode: t.type }
      this.tplDialogVisible = true
    },
    closeTplDialog() {
      this.tplDialogVisible = false
    },
    submitTpl() {
      const name = (this.tplForm.name || '').trim()
      if (!name) {
        this.$message && this.$message.warning('请输入模板名称')
        return
      }
      if (this.tplForm.id) {
        const t = this.templateList.find((x) => x.id === this.tplForm.id)
        if (t) {
          t.name = name
          t.type = this.tplForm.mode
          t.categoryText = (this.tplForm.categories || '').trim()
        }
        this.$message && this.$message.success('模板已更新')
      } else {
        this.templateList.push({
          id: Date.now(),
          name,
          type: this.tplForm.mode,
          icon: '🖼️',
          usageCount: 0,
          updatedAt: '今天',
          categoryText: (this.tplForm.categories || '').trim(),
          tags: []
        })
        this.$message && this.$message.success('模板创建成功')
      }
      this.tplDialogVisible = false
    },
    useTemplate(t) {
      this.$message && this.$message.success('已应用模板「' + t.name + '」，可在生成配置中选择')
    },
    copyTemplate(t) {
      this.templateList.push({
        ...t,
        id: Date.now(),
        name: t.name + '（副本）',
        usageCount: 0,
        tags: t.tags.map((tag) => ({ ...tag }))
      })
      this.$message && this.$message.success('已复制模板')
    },
    deleteTemplate(t) {
      const doDelete = () => {
        const i = this.templateList.findIndex((x) => x.id === t.id)
        if (i >= 0) this.templateList.splice(i, 1)
        this.$message && this.$message.success('模板已删除')
      }
      if (this.$confirm) {
        this.$confirm('确定删除模板「' + t.name + '」吗？', '提示', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(doDelete).catch(() => {})
      } else {
        doDelete()
      }
    },
    handleImport() {
      this.$message && this.$message.info('导入模板功能开发中')
    }
  }
}
</script>

<style scoped>
.gx-mi {
    --mi-red: #C8443C;
    --mi-red-light: #E6463D;
    --mi-pink: #FDF0EF;
    --mi-pink-2: rgb(255, 245, 245);
    --mi-beige: rgb(245, 240, 232);
    --mi-border: #EBE7DF;
    --mi-text: #3D3D3D;
    --mi-gray: #8A8A8A;
    color: var(--mi-text);
    font-size: 13px;
    padding-bottom: 30px;
}

/* ══════ 顶部说明栏 ══════ */
.gx-mi__banner {
    background: var(--mi-beige);
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 14px;
    border-radius: 8px;
    border: 2px solid rgb(224, 224, 236);
    margin-bottom: 14px;
    box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 4px;
}
.gx-mi__banner-icon { font-size: 20px; }
.gx-mi__banner-text { display: flex; flex-direction: column; gap: 2px; }
.gx-mi__banner-title { 
    font-size: 14px;
    font-weight: 700;
    color: rgb(26, 26, 46);
}
.gx-mi__banner-desc { 
    font-size: 11px;
    color: rgb(102, 102, 102);
    margin-top: 2px;
 }

/* ══════ Tab ══════ */
.gx-mi__tabs { 
    display: flex;
    margin-bottom: 18px; 
    background: rgb(240, 242, 245);
    border-radius: 8px;
    padding: 3px;
    gap: 2px;
    width: fit-content;
}
.gx-mi__tab {
    display: flex; align-items: center; gap: 5px;
    border: none; background: #F1F1F3; color: #666;
    padding: 7px 16px; border-radius: 6px; font-size: 13px; cursor: pointer;
}
.gx-mi__tab--on { background: #fff; color: var(--mi-red); font-weight: bold; box-shadow: 0 1px 4px rgba(0,0,0,.08); }
.gx-mi__tab-ico--gold { color: #E6A23C; }
.gx-mi__tab-ico--orange { color: #F56C41; }
.gx-mi__tab-ico--gray { color: #909399; }

/* ══════ 步骤条 ══════ */
.gx-mi__steps { display: flex; align-items: flex-start; margin: 6px 0 18px; }
.gx-mi__step { 
    display: flex; 
    align-items: center; 
    gap: 6px; 
    flex-shrink: 0; 
    justify-content: center;
    flex-direction: column;
}
.gx-mi__step-dot {
    width: 22px; height: 22px;
    border-radius: 50%;
    background: rgb(240, 242, 245);
    border: 2px solid rgb(224, 224, 236);
    display: flex; align-items: center; justify-content: center;
    font-size: 10px;
    color: rgb(153, 153, 153);
    font-weight: 400;
}
.gx-mi__step-label { color: #B0B0B0; font-size: 12px; white-space: nowrap; }
.gx-mi__step--on .gx-mi__step-dot { background: rgb(255, 245, 245);border: 2px solid rgb(200, 68, 60); color: rgb(200, 68, 60);font-weight: 700;}
.gx-mi__step--on .gx-mi__step-label { color: var(--mi-red); font-weight: bold; }
.gx-mi__step--done .gx-mi__step-dot { background: var(--mi-red);color: #fff; }
.gx-mi__step--done .gx-mi__step-label { color: var(--mi-red); }
.gx-mi__stepline { flex: 1; height: 2px; background: #E4E7ED; margin: 14px 14px; }
.gx-mi__stepline--on { background: var(--mi-red); }

/* ══════ 筛选区 ══════ */
.gx-mi__filter {
    background: #fff; border-radius: 8px; padding: 16px 18px;
    position: relative; margin-bottom: 12px;
    border: 1px solid rgb(224, 224, 236);
    box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 4px;
}
.gx-mi__filter-title { font-weight: bold; font-size: 13px; }
.gx-mi__filter-hint { position: absolute; right: 18px; top: 16px; font-size: 12px; color: var(--mi-gray); }
.gx-mi__frow { display: flex; flex-wrap: wrap; gap: 12px 22px; margin-top: 12px; align-items: center; }
.gx-mi__frow--last { justify-content: space-between; }
.gx-mi__fitem { display: flex; align-items: center; gap: 8px; }
.gx-mi__fitem label { color: #666; font-size: 12px; white-space: nowrap; }
.gx-mi__fitem--months { flex-wrap: wrap; }
.gx-mi__input, .gx-mi__select {
    height: 30px; border: 1px solid #DCDFE6; border-radius: 4px;
    padding: 0 10px; font-size: 12px; background: #fff; color: var(--mi-text);
    min-width: 110px; box-sizing: border-box; outline: none;
}
.gx-mi__input:focus, .gx-mi__select:focus { border-color: var(--mi-red); }
.gx-mi__input--flex { flex: 1; min-width: 260px; }
.gx-mi__chips { display: flex; flex-wrap: wrap; gap: 6px; }
.gx-mi__chip {
    min-width: 26px; height: 26px; padding: 0 7px; border: 1px solid #E4E7ED;
    background: #fff; border-radius: 4px; font-size: 12px; color: #666; cursor: pointer;
}
.gx-mi__chip--on { background: rgb(255, 245, 245); border-color: var(--mi-red); color: var(--mi-red); }
.gx-mi__fbtns { display: flex; gap: 8px; margin-left: auto; }

/* ══════ 按钮 ══════ */
.gx-mi__btn {
    height: 30px; padding: 0 16px; border-radius: 4px; font-size: 13px;
    cursor: pointer; border: 1px solid transparent; white-space: nowrap;
}
.gx-mi__btn--red { background: var(--mi-red); color: #fff; }
.gx-mi__btn--red:hover { background: var(--mi-red-light); }
.gx-mi__btn--red:disabled { background: #F0B6B1; cursor: not-allowed; }
.gx-mi__btn--plain { background: #fff; border-color: #DCDFE6; color: #606266; }
.gx-mi__btn--plain:hover { border-color: var(--mi-red); color: var(--mi-red); }
.gx-mi__btn--lg { height: 36px; padding: 0 22px; font-size: 13px; font-weight: bold; }
.gx-mi__btn--xs { height: 24px; padding: 0 10px; font-size: 12px; border-radius: 4px; }

/* ══════ 复选 ══════ */
.gx-mi__check {
    width: 14px; height: 14px; border: 1px solid #C0C4CC; border-radius: 2px;
    display: inline-flex; align-items: center; justify-content: center;
    background: #fff; cursor: pointer; flex-shrink: 0;
}
.gx-mi__check--on { background: var(--mi-red); border-color: var(--mi-red); }
.gx-mi__check--blue.gx-mi__check--on { background: #409EFF; border-color: #409EFF; color: #fff; }
.gx-mi__check--blue.gx-mi__check--on::after { content: '✓'; font-size: 10px; line-height: 1; }
.gx-mi__selrow { display: flex; align-items: center; gap: 20px; padding: 6px 4px 10px; position: relative; }
.gx-mi__checkline { display: flex; align-items: center; gap: 6px; font-size: 12px; color: #606266; cursor: pointer; }
.gx-mi__checkline--red { color: var(--mi-red); }
.gx-mi__selcount { margin-left: auto; font-size: 12px; color: #606266; }
.gx-mi__selcount b { color: var(--mi-red); }

/* ══════ 表格 ══════ */
.gx-mi__table {
    background: #fff; border-radius: 8px; overflow: hidden;
    border: 1px solid #F0EDE6;
}
.gx-mi__table table { width: 100%; border-collapse: collapse; }
.gx-mi__table th {
    background: rgb(246, 247, 250); color: #6B6252; font-weight: normal; font-size: 12px;
    padding: 10px 12px; text-align: left; white-space: nowrap;
}
.gx-mi__table td { padding: 12px; font-size: 13px; border-top: 1px solid #F4F2EC; vertical-align: middle; }
.gx-mi__tr--on { background: var(--mi-pink-2); }
.gx-mi__mono { color: #4A4A4A; }
.gx-mi__empty { text-align: center; color: var(--mi-gray); padding: 40px 0; }
.gx-mi__mono--num{
    font-size: 12px;
    font-weight: 600;
    color: rgb(26, 26, 46);
}
/* 商品信息 */
.gx-mi__goods { display: flex; align-items: flex-start; gap: 8px; min-width: 220px; }
.gx-mi__goods-icon {
    width: 34px; height: 34px; border-radius: 6px; display: inline-flex;
    align-items: center; justify-content: center; font-size: 17px; flex-shrink: 0;
    border: 1px solid rgba(0,0,0,.04);
}
.gx-mi__goods-info { min-width: 0; }
.gx-mi__goods-title {
    max-width: 260px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; font-weight: 500;
}
.gx-mi__goods-code { font-size: 11px; color: var(--mi-gray); margin: 4px 0 4px; }

/* 状态标签 */
.gx-mi__tag {
    display: inline-block; padding: 1px 8px; border-radius: 3px; font-size: 11px;
    border: 1px solid transparent; white-space: nowrap;
}
.gx-mi__tag--green { color: #67C23A; background: #F0F9EB; border-color: #C2E7B0; }
.gx-mi__tag--red { color: var(--mi-red); background: #FEF0F0; border-color: #F8C4C4; }
.gx-mi__tag--orange { color: #E6A23C; background: #FDF6EC; border-color: #F5DAB1; }
.gx-mi__tag--blue { color: #409EFF; background: #ECF5FF; border-color: #C6E2FF; }
.gx-mi__tag--blue-line { color: #409EFF; background: #fff; border-color: #409EFF; }
.gx-mi__tag--yellow { color: #C99A1B; background: #FCF8E8; border-color: #F0E2A8; }
.gx-mi__tag--gray { color: #909399; background: #F4F4F5; border-color: #E0E0E0; }

/* 产品图槽位 */
.gx-mi__slots { display: flex; gap: 4px; }
.gx-mi__slot {
    width: 26px; height: 26px; border-radius: 4px; display: inline-flex;
    align-items: center; justify-content: center; font-size: 12px;
    background: #F5F6F8; color: #B0B4BB;
}
.gx-mi__slot--ready { background: #EAF4FE; color: #409EFF; }
.gx-mi__slot--warn { background: #FDF0E8; color: #F5865B; }

/* ══════ 底部悬浮条 ══════ */
.gx-mi__footbar {
    position: sticky;
    bottom: 0;
    z-index: 50;
    display: flex; align-items: center; justify-content: space-between;
    gap: 12px;
    margin-top: 14px;
    padding: 12px 20px;
    background: #fff;
    border: 1px solid #EBEEF5;
    border-radius: 8px 8px 0 0;
    box-shadow: 0 -4px 16px rgba(0, 0, 0, .06);
}
.gx-mi__foot-info { color: #606266; font-size: 12px; }
.gx-mi__foot-btns { display: flex; gap: 10px; }
.gx-mi__fc-orange { color: #E6A23C; }
.gx-mi__fc-red { color: var(--mi-red); }
.gx-mi__fc-red-t {     
    font-size: 18px;
    color: rgb(200, 68, 60); }

/* ══════ 步骤2：方式卡片 ══════ */
.gx-mi__notice {
    background: #FCF6E3; border: 1px solid #F2E4B8; border-radius: 6px;
    padding: 10px 14px; font-size: 13px; color: rgb(26, 26, 46); margin-bottom: 14px;
    display: flex; gap: 14px; align-items: center;
}
.gx-mi__notice-link { color: var(--mi-red); cursor: pointer; font-size: 12px; }
.gx-mi__modes { display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; }
.gx-mi__mode {
    position: relative; background: #fff; border: 2px solid #EDEDED; border-radius: 8px;
    padding: 18px 20px; cursor: pointer;
}
.gx-mi__mode--on { border-color: var(--mi-red); background: var(--mi-pink); }
.gx-mi__mode-tag {
     color: var(--mi-red);
    font-size: 10px; padding: 1px 7px; border-radius: 3px; margin-left: 2px;
    border: 1px solid rgb(255, 205, 210);
}
.gx-mi__mode-check {
    position: absolute; right: 10px; top: 10px; width: 18px; height: 18px; border-radius: 50%;
    background: var(--mi-red); color: #fff; font-size: 11px;
    display: flex; align-items: center; justify-content: center;
}
.gx-mi__mode-head { display: flex; align-items: center; gap: 8px; margin-bottom: 8px; }
.gx-mi__mode-icon { font-size: 18px; }
.gx-mi__mode-name { font-size: 15px; font-weight: bold; }
.gx-mi__mode-desc { color: var(--mi-gray); font-size: 12px; margin-bottom: 12px; }
.gx-mi__mode-points { list-style: none; padding: 0; margin: 0; }
.gx-mi__mode-points li { font-size: 12px; line-height: 2; }
.gx-mi__mode-points li span { margin-right: 6px; }
.gx-mi__mode-points li.is-ok { color: #67C23A; }
.gx-mi__mode-points li.is-warning { color: #E6A23C; }
.gx-mi__mode-points li.is-no { color:rgb(153, 153, 153); }

/* ══════ 步骤3：配置卡 ══════ */
.gx-mi__crumb {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 14px;
    border-radius: 8px;
    background: rgb(230, 244, 255);
    border: 1px solid rgb(145, 202, 255);
    margin-bottom: 14px;
    font-size: 12px;
}
.gx-mi__crumb-tag {
    padding: 2px 7px;
    border-radius: 3px;
    background: rgb(230, 244, 255);
    border: 1px solid rgb(145, 202, 255);
    font-family: "Noto Sans SC", sans-serif;
    font-size: 10px;
    font-weight: 500;
    color: rgb(22, 119, 255);
    white-space: nowrap;
}
.gx-mi__crumb-link { 
    background: none;
    border: none;
    cursor: pointer;
    color: rgb(22, 119, 255);
    font-size: 12px;
}
.gx-mi__crumb-link-t{
    background: none;
    border: none;
    cursor: pointer;
    color: rgb(153, 153, 153);
    font-size: 12px;
}
.gx-mi__crumb-right { margin-left: auto; color: var(--mi-gray); }

.gx-mi__pcard {
    background: #fff; border: 1px solid #EDE4E3; border-radius: 8px;
    margin-bottom: 12px; overflow: hidden;
}
.gx-mi__pcard-head {
    display: flex; align-items: center; gap: 10px; padding: 10px 14px;
    cursor: pointer; user-select: none;
    background-color: rgb(250, 250, 250);
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.gx-mi__pcard-info {
    display: flex; align-items: center; gap: 4px;margin-bottom: 5px;
}
.gx-mi__code{
    font-size: 11px;
    color: rgb(200, 68, 60);
    font-weight: 600;
}
.gx-mi__pcard-content {
    display: flex; align-items: center; gap: 10px;
}
.gx-mi__pcard-code { 
    color: rgb(153, 153, 153);
    width: 60px;
 }
.gx-mi__pcard-title {
    color: #666; font-size: 12px; white-space: nowrap; overflow: hidden;
    text-overflow: ellipsis; flex: 1; min-width: 0;
}
.gx-mi__pcard-fold { color: var(--mi-gray); font-size: 14px; }
.gx-mi__pcard-body { padding: 14px; border-top: 1px solid #F2E9E8; }

.gx-mi__cfg-cols { display: grid; grid-template-columns: 1fr 1.2fr; gap: 14px; }
.gx-mi__cfg-col { background: #F7F8FA; border-radius: 6px; padding: 12px 14px; }
.gx-mi__cfg-title { font-size: 13px; font-weight: bold; margin-bottom: 10px; }
.gx-mi__cfg-more { float: right; color: var(--mi-red); font-size: 12px; font-weight: normal; cursor: pointer; }

.gx-mi__imgtabs { display: flex; gap: 4px; margin-bottom: 10px; }
.gx-mi__imgtab {
    font-size: 11px; padding: 2px 10px; border-radius: 3px; color: #909399; cursor: pointer;
}
.gx-mi__imgtab--on { background: #fff; color: var(--mi-red); font-weight: bold; box-shadow: 0 1px 3px rgba(0,0,0,.08); }

.gx-mi__imgslots { display: flex; gap: 8px; }
.gx-mi__imgslot {
    position: relative; width: 46px; height: 46px; border-radius: 6px;
    background: #ECEAE6; color: #A8A8A8; font-size: 13px;
    display: inline-flex; align-items: center; justify-content: center; text-align: center;
}
.gx-mi__imgslot--pick { background: #E8E2DC; border: 2px solid var(--mi-red); color: #8A8378; }
.gx-mi__imgslot-badge {
    position: absolute; right: -5px; top: -5px; width: 15px; height: 15px; border-radius: 50%;
    background: var(--mi-red); color: #fff; font-size: 10px;
    display: flex; align-items: center; justify-content: center;
}
.gx-mi__imgslot--empty { background: #F2F3F5; }
.gx-mi__imgslot--add {
    background: #fff; border: 1px dashed #C0C4CC; color: #B0B4BB; font-size: 11px; line-height: 1.3;
}
.gx-mi__cfg-foot { margin-top: 8px; font-size: 11px; color: var(--mi-gray); }

.gx-mi__tpls { display: flex; gap: 8px; flex-wrap: wrap; margin-bottom: 12px; }
.gx-mi__tpl {
    width: 62px; border: 1px solid #E4E7ED; border-radius: 6px; background: #fff;
    text-align: center; padding: 6px 2px; cursor: pointer; white-space: pre-line;
}
.gx-mi__tpl--on { border-color: var(--mi-red); background: var(--mi-pink); }
.gx-mi__tpl-ico { display: block; font-size: 15px; color: #606266; margin-bottom: 3px; }
.gx-mi__tpl-name { font-size: 10px; color: #606266; }
.gx-mi__refarea { display: flex;gap: 10px;flex-direction: column;justify-content: flex-start; }
.gx-mi__refslot{
    display: flex;
    align-items: center;
    gap: 5px;
}
.gx-mi__refhint { font-size: 11px; color: #B0B4BB; line-height: 1.5;}

.gx-mi__cfg-row {
    display: flex; align-items: center; justify-content: space-between;
    background: #F7F8FA; border-radius: 6px; padding: 10px 14px; margin-top: 10px;
}
.gx-mi__cfg-row .gx-mi__cfg-title { margin-bottom: 0; }
.gx-mi__cfg-row--block { display: block; }
.gx-mi__cfg-row--block .gx-mi__cfg-title { margin-bottom: 10px; }
.gx-mi__switchline { display: flex; align-items: center; gap: 8px; font-size: 12px; color: #606266; }
.gx-mi__switch {
    width: 34px; height: 18px; border-radius: 10px; background: #DCDFE6;
    position: relative; cursor: pointer; transition: background .2s;
}
.gx-mi__switch i {
    position: absolute; left: 2px; top: 2px; width: 14px; height: 14px; border-radius: 50%;
    background: #fff; transition: left .2s;
}
.gx-mi__switch--on { background: var(--mi-red); }
.gx-mi__switch--on i { left: 18px; }

.gx-mi__cfg-rowhead { display: flex; align-items: center; justify-content: space-between; }

.gx-mi__face { margin-top: 12px; }
.gx-mi__face-tabs {
    display: flex; gap: 4px; background: #F2F3F5; border-radius: 6px; padding: 4px; margin-bottom: 12px;
}
.gx-mi__face-tab {
    display: inline-flex; align-items: center; gap: 4px;
    font-size: 12px; color: #909399; background: transparent; border: none; outline: none;
    padding: 6px 14px; border-radius: 4px; cursor: pointer; white-space: nowrap;
}
.gx-mi__face-tab--on { background: #fff; color: var(--mi-red); font-weight: bold; box-shadow: 0 1px 4px rgba(0,0,0,.08); }
.gx-mi__ft-ico { font-size: 13px; line-height: 1; }
.gx-mi__ft-ico--red { color: var(--mi-red); }
.gx-mi__ft-ico--gold { color: #E6A23C; }

.gx-mi__face-grid { display: flex; gap: 10px; flex-wrap: wrap; margin-bottom: 12px; }
.gx-mi__face-card {
    width: 82px; background: #fff; border: 1px solid #E4E7ED; border-radius: 8px;
    padding: 10px 4px 8px; display: flex; flex-direction: column; align-items: center; gap: 6px; cursor: pointer;
}
.gx-mi__face-card--on { border-color: var(--mi-red); background: var(--mi-pink); }
.gx-mi__face-ico { font-size: 28px; line-height: 1; }
.gx-mi__face-name { font-size: 11px; color: #606266; text-align: center; }
.gx-mi__face-card--on .gx-mi__face-name { color: var(--mi-red); }

.gx-mi__face-textarea {
    width: 100%; box-sizing: border-box; min-height: 64px; resize: vertical;
    border: 1px solid #DCDFE6; border-radius: 6px; padding: 8px 10px;
    font-size: 12px; color: #303133; line-height: 1.6; outline: none; margin-bottom: 12px;
    font-family: inherit;
}
.gx-mi__face-textarea:focus { border-color: var(--mi-red); }

.gx-mi__face-uploadbox {
    width: 96px; height: 96px; background: #fff; border: 1px dashed #C0C4CC; border-radius: 8px;
    display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 6px;
    cursor: pointer; margin-bottom: 12px;
}
.gx-mi__face-uploadico { font-size: 24px; color: #B0B4BB; line-height: 1; }
.gx-mi__face-uploadtxt { font-size: 11px; color: #909399; }

.gx-mi__face-tip {
    background: #FFF8E6; border-radius: 4px; padding: 8px 12px;
    font-size: 12px; color: #B8860B; line-height: 1.5;
}
.gx-mi__face-tip--red { background: #FEF0F0; color: #F56C6C; }

.gx-mi__prompt-tags { display: flex; gap: 8px; flex-wrap: wrap; margin-bottom: 10px; }
.gx-mi__ptag {
    font-size: 11px; color: #B8860B; background: #FCF8E8; border: 1px solid #F0E2A8;
    border-radius: 3px; padding: 2px 8px;
}
.gx-mi__prompt-line { display: flex; align-items: center; gap: 8px; }
.gx-mi__prompt-line label { font-size: 12px; color: #606266; white-space: nowrap; }
.gx-mi__cfg-note { font-size: 11px; color: #B0B4BB; margin-top: 6px; }

.gx-mi__cfg-col--prompt { display: flex; flex-direction: column; }
.gx-mi__prompt-textarea {
    width: 100%; box-sizing: border-box; flex: 1; min-height: 96px; resize: vertical;
    border: 1px solid #DCDFE6; border-radius: 6px; padding: 8px 10px;
    font-size: 12px; color: #303133; line-height: 1.6; outline: none;
    font-family: inherit; background: #fff;
}
.gx-mi__prompt-textarea:focus { border-color: #409EFF; }
.gx-mi__prompt-opts { display: flex; align-items: center; gap: 16px; margin-top: 8px; }

.gx-mi__copyopts { display: flex; flex-direction: column; gap: 8px; }
.gx-mi__copyopt {
    display: flex; align-items: flex-start; gap: 8px; border: 1px solid #E4E7ED;
    border-radius: 6px; padding: 10px 12px; cursor: pointer; background: #fff;
}
.gx-mi__copyopt--on { border-color: var(--mi-red); background: var(--mi-pink); }
.gx-mi__radio {
    width: 14px; height: 14px; border-radius: 50%; border: 1px solid #C0C4CC;
    margin-top: 2px; flex-shrink: 0; position: relative; background: #fff;
}
.gx-mi__radio--on { border-color: var(--mi-red); }
.gx-mi__radio--on::after {
    content: ''; position: absolute; left: 3px; top: 3px; width: 6px; height: 6px;
    border-radius: 50%; background: var(--mi-red);
}
.gx-mi__copyopt-body { display: flex; flex-direction: column; gap: 2px; }
.gx-mi__copyopt-body b { font-size: 12px; }
.gx-mi__copyopt-body i { font-style: normal; font-size: 11px; color: var(--mi-gray); }

/* ══════ 步骤4 ══════ */
.gx-mi__done { text-align: center; padding: 70px 0; }
.gx-mi__done-icon { font-size: 44px; }
.gx-mi__done-title { font-size: 18px; font-weight: bold; margin: 14px 0 6px; }
.gx-mi__done-desc { color: var(--mi-gray); font-size: 13px; margin-bottom: 22px; }

/* ══════ 生成记录 ══════ */
.gx-mi__stats { display: flex; gap: 14px; margin-bottom: 14px; position: relative; }
.gx-mi__stat {
    padding: 10px 18px;
    border-radius: 8px;
    background: rgb(255, 255, 255);
    border: 2px solid rgb(224, 224, 236);
    cursor: pointer;
    text-align: center;
    min-width: 55px;
    transition: all 0.15s ease 0s;
    box-shadow: none;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.gx-mi__stat-num { font-size: 24px; font-weight: bold; }
.gx-mi__stat-label { font-size: 11px; color: #606266; }
.gx-mi__stats-right { margin-left: auto; align-self: center; font-size: 12px; color: #606266; }

.gx-mi__td-stack { display: flex; flex-direction: column; gap: 2px; }
.gx-mi__td-stack i { font-style: normal; font-size: 11px; }
.gx-mi__link-cyan { color: rgb(22, 119, 255); cursor: pointer; }
.gx-mi__progress { display: flex;  gap: 8px; min-width: 150px;flex-direction: column;justify-content: flex-start; }
.gx-mi__progress-bar { height: 6px; background: #F0F2F5; border-radius: 3px; overflow: hidden;width: 100%; }
.gx-mi__progress-in { height: 100%; background: #67C23A; border-radius: 3px; }
.gx-mi__progress-txt { font-size: 11px; color: #606266; white-space: nowrap; }
.gx-mi__progress-txt i { font-style: normal; margin-left: 2px; }
.gx-mi__ops { display: flex; gap: 12px; }
.gx-mi__op-link { color: #3FB6E0; font-size: 12px; cursor: pointer; white-space: nowrap; }
.gx-mi__op-link--red { color: var(--mi-red); }
.gx-mi__tr-detail td { background: rgb(249, 250, 251); padding: 10px 16px; }
.gx-mi__detail-head { font-size: 12px; font-weight: bold; color: #606266; padding: 4px 0 8px; }
.gx-mi__detail-item { display: flex; align-items: center; gap: 10px; padding: 6px 0; font-size: 12px; border-bottom: 1px solid rgb(224, 224, 236); justify-content: space-between;}
.gx-mi__detail-title { color: #4A4A4A; }
.gx-mi__detail-meta { color: #909399; }
.gx-mi__tag--right { margin-left: 12px; }

/* ══════ 模板管理 ══════ */
.gx-mi__tplbar { display: flex; align-items: center; gap: 10px; margin-bottom: 14px; }
.gx-mi__tplfilters { display: flex; gap: 8px; }
.gx-mi__tplfilter {
    border: none; background: #F1F1F3; color: #666;
    padding: 6px 16px; border-radius: 5px; font-size: 12px; cursor: pointer;
}
.gx-mi__tplfilter--on { background: #fff; color: var(--mi-red); font-weight: bold; box-shadow: 0 1px 4px rgba(0,0,0,.08); }
.gx-mi__tplsearch { min-width: 170px; height: 30px; background: #fff; }
.gx-mi__tplbar-right { margin-left: auto; display: flex; gap: 8px; }

/* 统计卡 */
.gx-mi__tplstats { display: grid; grid-template-columns: repeat(5, 1fr); gap: 14px; margin-bottom: 16px; }
.gx-mi__tplstat {
    background: #fff; border-radius: 8px; padding: 12px 0;
    display: flex; flex-direction: column; align-items: center; gap: 4px;
}
.gx-mi__tplstat-num { font-size: 22px; font-weight: bold; line-height: 1.2; }
.gx-mi__tplstat-label { font-size: 12px; color: #909399; }

/* 卡片网格 */
.gx-mi__tplgrid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; }
.gx-mi__tplcard {
    background: #fff; border: 1px solid #EDEDED; border-radius: 8px;
    overflow: hidden; display: flex; flex-direction: column;
}
.gx-mi__tplcard-head {
    position: relative; height: 88px;
    display: flex; align-items: center; justify-content: center;
}
.gx-mi__tplcard-head--copy { background: linear-gradient(135deg, rgba(200, 68, 60, 0.094), rgba(200, 68, 60, 0.024)); }
.gx-mi__tplcard-head--style { background: linear-gradient(135deg, rgba(184, 134, 11, 0.094), rgba(184, 134, 11, 0.024)); }
.gx-mi__tplcard-head--custom { background: linear-gradient(135deg, rgba(22, 119, 255, 0.094), rgba(22, 119, 255, 0.024)); }
.gx-mi__tplcard-ico { font-size: 30px; line-height: 1; }
.gx-mi__tplcard-badge {
    position: absolute; right: 10px; top: 10px;
    font-size: 10px; padding: 1px 7px; border-radius: 3px;
}
.gx-mi__tplcard-badge--copy { color: rgb(200, 68, 60); background: rgb(255, 245, 245); border: 1px solid rgb(255, 205, 210);}
.gx-mi__tplcard-badge--style { color: rgb(184, 134, 11); background: rgb(255, 251, 230); border: 1px solid rgb(255, 229, 143);}
.gx-mi__tplcard-badge--custom { color: rgb(22, 119, 255); background: rgb(230, 244, 255); border: 1px solid rgb(145, 202, 255); }

.gx-mi__tplcard-body { padding: 12px 14px; display: flex; flex-direction: column; flex: 1; }
.gx-mi__tplcard-name { font-size: 14px; font-weight: bold; color: #30313A; margin-bottom: 8px; }
.gx-mi__tplcard-tags { display: flex; flex-wrap: wrap; gap: 6px; min-height: 22px; }
.gx-mi__tplcard-info{display: flex;justify-content: space-between;margin-top: 5px;align-items: center;}
.gx-mi__tplcard-info-l{
    display: flex;
    align-items: center;
    gap: 5px;
}
.gx-mi__tplcard-info-l-item{
    border-radius: 2px;
    background: rgb(240, 242, 245);
    font-size: 9px;
    color: rgb(153, 153, 153);
    padding: 2px 6px;
}
.gx-mi__ttag {
    font-size: 11px; padding: 1px 7px; border-radius: 3px;
    background: #F4F5F7; color: #909399; border: 1px solid #EDEEF0; white-space: nowrap;
}
.gx-mi__ttag--fixed { background: #FFF9E8; color: #B8860B; border-color: #F0E2A8; }

.gx-mi__tplcard-foot {
    margin-top: auto; padding-top: 12px;
    display: flex; align-items: center; gap: 8px; flex-wrap: wrap;
}
.gx-mi__tplcard-usage { font-size: 11px; color: #B0B4BB; white-space: nowrap; }
.gx-mi__tplcard-ops { display: flex; gap: 6px; }
.gx-mi__tplcard-del {
    margin-left: auto; font-size: 12px; color: #909399; cursor: pointer; white-space: nowrap;
}
.gx-mi__tplcard-del:hover { color: var(--mi-red); }

/* 新建卡 */
.gx-mi__tplcard--add {
    border: 1px dashed #C6C8CC; background: transparent;
    align-items: center; justify-content: center; text-align: center;
    min-height: 215px; cursor: pointer; gap: 8px;
}
.gx-mi__tplcard--add:hover { border-color: var(--mi-red); }
.gx-mi__tplcard-addico {
    width: 40px; height: 40px; border-radius: 50%; background: #F0F1F3;
    color: #909399; font-size: 20px; display: flex; align-items: center; justify-content: center;
}
.gx-mi__tplcard-addname { font-size: 13px; font-weight: bold; color: #606266; }
.gx-mi__tplcard-adddesc { font-size: 12px; color: #B0B4BB; max-width: 200px; line-height: 1.6; }

/* ══════ 新建模板弹窗 ══════ */
.gx-mi__modal-mask {
    position: fixed; top: 0; right: 0; bottom: 0; left: 0; background: rgba(0,0,0,.45);
    display: flex; align-items: center; justify-content: center;
    z-index: 2000;
}
.gx-mi__modal {
    background: #fff; border-radius: 12px; width: 520px; max-width: calc(100vw - 40px);
    box-shadow: 0 12px 40px rgba(0,0,0,.2);
}
.gx-mi__modal-head {
    display: flex; align-items: center; justify-content: space-between;
    padding: 20px 24px 0;
}
.gx-mi__modal-title { font-size: 18px; font-weight: bold; color: #30313A; }
.gx-mi__modal-close { font-size: 18px; color: #909399; cursor: pointer; line-height: 1; }
.gx-mi__modal-close:hover { color: var(--mi-red); }
.gx-mi__modal-body { padding: 18px 24px 4px; }
.gx-mi__mfield { margin-bottom: 18px; }
.gx-mi__mfield label { display: block; font-size: 13px; color: #606266; margin-bottom: 8px; }
.gx-mi__minput { width: 100%; height: 38px; min-width: 0; box-sizing: border-box; }
.gx-mi__mradios { display: flex; gap: 26px; }
.gx-mi__mradio { display: flex; align-items: center; gap: 8px; font-size: 13px; color: #30313A; cursor: pointer; }
.gx-mi__mtip {
    background: #FFF8E6; border: 1px solid #F5E6B8; border-radius: 6px;
    padding: 10px 14px; font-size: 12px; color: #B8860B; line-height: 1.7;
}
.gx-mi__modal-foot {
    display: flex; justify-content: flex-end; gap: 12px;
    padding: 16px 24px 22px;
}
</style>
